<template>
    <section class="w-100 row-12 col-12">
        <label class="col-12">{{label}}</label>
        <div class="col-6 folderName" >
            <small v-if="!selectedFolder">Nie wybrałeś folderu</small>
            <small v-else>Wybrałeś folder "{{selectedFolder.name}}"</small>
        </div>
        <button @click.prevent="showModal('#selectFolderModal')" class="col-6">Przeglądaj foldery</button>
        <div class="modal" id="selectFolderModal">
            <div class="modal-header">
                Wybierz folder do zapisu
            </div>
            <div class="modal-body center-flex-a">
                <folder-list :folderType="folderType" :autoSelect="false" @select-folder="changeFolder" ref="folders"
                             class="col-12"></folder-list>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#selectFolderModal')">Anuluj</button>
            </div>
        </div>
    </section>
</template>

<script>
    import FolderList from './FolderList';

    export default {
        name: "FolderSelect",
        data: function () {
            return {
                selectedFolder: null
            }
        },
        props: {
            value: {},
            label: {
                type: String,
                default: "Wybierz folder do zapisu*"
            },
            folderType: {
                type: String,
                default: "animations"
            }
        },
        components: {
            'folder-list': FolderList,
        },
        watch: {
            value: function(newVal, oldVal) { // watch it
                this.select(newVal);
            }
        },
        methods: {
            select(id){
                if(id){
                    this.$refs.folders.setFolderActive(id);
                }
            },
            changeFolder(folder) {
                if(!folder) return;
                this.selectedFolder = folder;
                this.$emit('input', folder.id);
                this.hideModal('#selectFolderModal');
            }
        },
        mounted: function(){
            if(this.value){
                this.$refs.folders.setFolderActive(this.value);
            }
        }
    }
</script>

<style scoped lang="scss">

    #selectFolderModal{
        min-height: 600px;
    }

    .folderName{
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>